import infrastructureIcon from 'assets/ic_theme_infrastructure.svg';
import crossBorderIcon from 'assets/ic_theme_cross_border.svg';
import productionIcon from 'assets/ic_theme_production.svg';
import genericIcon from 'assets/ic_theme_generic.svg';

export const GENERIC_THEME_ICON: string = genericIcon;

// Keyed by the Tema's Spanish name, lowercased.
const THEME_ICONS: { [name: string]: string } = {
  'infraestructura': infrastructureIcon,
  'procesos transfronterizos': crossBorderIcon,
  'producción y servicios': productionIcon,
};

/** The Tema's icon, or a generic one for a Tema the design has no icon for. */
export const themeIcon = (theme: { name: string; nameEs?: string }): string =>
  THEME_ICONS[(theme.nameEs || theme.name || '').trim().toLowerCase()] || GENERIC_THEME_ICON;
